// extracted by mini-css-extract-plugin
export default {"spinMobile":"machine-view_spinMobile__Ofq0O"};